<template>
    <div>

        <button class="button button--small button--validate" @click="openModal()">Add New</button>

        <modal class="add-new-model" name="add-new">
            <header class="modal__header">
                Add new
                <button type="button" class="modal__close">
                    <span symbol="close_modal" class="icon icon--close_modal">
                        <svg>
                            <title>close_modal</title>
                            <use xlink:href="#close_modal"></use>
                        </svg>
                    </span>
                </button>
            </header>
            <div class="modal__content">
                <form @submit.prevent="addNew()">
                    <div class="form-group">
                        <label for="email">Name:</label>
                        <input class="form-control" v-model="name">
                    </div>

                    <div class="form-group">
                        <label for="Attributes">Attribute Set:</label>
                        <select class="form-control" v-model="attributeSelected">
                            <option v-for="attribute in attributes" :value="attribute.id">{{attribute.name}}</option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-default button-gray">Submit</button>
                </form>
            </div>
        </modal>


    </div>
</template>
<script>


    import VModal from 'vue-js-modal'
    import axios from 'axios'

    Vue.use(VModal)


    export default {
        data() {
            return {
                name: '',
                attributes: '',
                attributeSelected: '',
            }
        },
        methods: {
            openModal() {
                console.log("hi");
                this.name = "";
                this.show();
            },
            addNew() {
                axios.post(this.adminApiUrl+'/add-new-product', {
                    name: this.name,
                    attribute: this.attributeSelected,
                })
                    .then(function (response) {

                        window.location.href = response.data.url;
                    })
                    .catch(function (error) {

                    });

            },
            getAttributes() {

                let that = this;

                axios.get(this.adminApiUrl+'/attribute-set')
                    .then(function (response) {
                        that.attributes = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });

            },
            show() {
                this.$modal.show('add-new');
            },
            hide() {
                this.$modal.hide('add-new');
            }
        },
        mounted() {
            this.getAttributes();
        },

        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            baseUrl: function () {
                return window.location.href;
            },
            adminApiUrl: function () {
                return process.env.MIX_ADMIN_API_URL;
            },
        },
    }
</script>
